<div class="category-scroller" role="group" aria-label="News categories">

  <button class="arrow left" (click)="scroll(-200)" [disabled]="atStart" aria-label="Scroll left">
    &lsaquo;
  </button>

  <div #scroller class="categories" (scroll)="onScroll()"
    role="listbox" aria-orientation="horizontal"
    (keydown)="onKeydown($event)"
    [attr.aria-activedescendant]="'category-'+activeIndex"
  >  
    <button class="category btn-ghost-primary btn-pill btn btn-sm p-2"
      [class.active]="selectedCategoryId() == null"
      [attr.aria-selected]="selectedCategoryId() == null"
      id="category-{{0}}"
      [attr.tabindex]="activeIndex === 0 ? 0 : -1"
      (click)="select(null)"
      (focus)="setActive(0)"
    >
      {{ 'news.categories.all' | translate }}
    </button>

    @for(category of categories(); track category.id; let i = $index) {
      <button class="category btn-ghost-primary btn-pill btn btn-sm p-2"
        [class.active]="selectedCategoryId() == category.id"
        [attr.aria-selected]="selectedCategoryId() == category.id"
        id="category-{{i+1}}"
        [attr.tabindex]="activeIndex === i+1 ? 0 : -1"
        (click)="select(category.id)"
        (focus)="setActive(i+1)"
      >
        {{ category | newsCategory }}
      </button>
    }

  </div>

  <button class="arrow right" (click)="scroll(200)" [disabled]="atEnd" aria-label="Scroll right">
    &rsaquo;
  </button>
</div>
